import { RouterPages } from 'shared/model/routes'

import { Suspense } from 'react'

import { Navigate, RouteObject } from 'react-router-dom'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { BonusHistoryLazy } from './routes/BonusHistory'
import { EditGeneralInfoLazy } from './routes/EditGeneralInfo'
import { GeneralInfoLazy } from './routes/GeneralInfo'
import { OrderHistoryLazy } from './routes/OrderHistory'
import { SavedAddressesLazy } from './routes/SavedAddresses'

export const clientsDetailRoutes: RouteObject[] = [
  {
    path: 'general-info',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <GeneralInfoLazy />
      </Suspense>
    ),
  },
  {
    path: 'general-info/edit-client',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <EditGeneralInfoLazy />
      </Suspense>
    ),
  },
  {
    path: 'order-history',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <OrderHistoryLazy />
      </Suspense>
    ),
  },
  {
    path: 'bonus-history',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <BonusHistoryLazy />
      </Suspense>
    ),
  },
  {
    path: 'saved-addresses',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <SavedAddressesLazy />
      </Suspense>
    ),
  },
  {
    path: '',
    element: <Navigate to={RouterPages.generalInfo} />,
  },
]
